import { useContext, useRef } from "react";
import constants from "../../../constants";
import { useLocation } from "react-router-dom";
import { getDataFromStorage } from "../../../util";
import useAxiosPrivate from "../../useAxiosPrivate";
import AlertContext from "../../../context/AlertContext";
import useCommonFunctionHooks from "../../useCommonFunctionHooks";
import { MockTestPageContext } from "../../../context/MockTestPageContext";

export default function MockTestLibraryHooks() {
  const Alert = useContext(AlertContext);
  const MockTestPageCxt = useContext(MockTestPageContext);

  const axios = useAxiosPrivate();

  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();

  const { pathname } = useLocation();

  const mockTestRefs = {
    mcq: useRef(null),
    relevant: useRef(null),
    descriptive: useRef(null),
    codingSnippet: useRef(null),
    codingChallenge: useRef(null),
    videoAssessment: useRef(null),
    group: useRef(null),
  };

  const scroll = (direction, refKey) => {
    if (mockTestRefs[refKey]?.current) {
      const scrollAmount = 900;

      mockTestRefs[refKey].current.scrollBy({
        behavior: "smooth",
        left: direction === "left" ? -scrollAmount : scrollAmount,
      });
    }
  };

  const handleSearch = () => {
    MockTestPageCxt.setSearchMockTest(
      MockTestPageCxt.mockTest.filter((test) =>
        test.name
          .toLowerCase()
          .includes(MockTestPageCxt.searchText.toLowerCase()),
      ),
    );
  };

  const getTime = (seconds) => {
    const min = Math.floor(seconds / 60);

    return " " + min + " mins";
  };

  const getTestType = (type) => {
    if (type.hasOwnProperty("toc")) {
      return "Test Series";
    } else {
      if ((type.libtype || type.testtype) === constants.libTypeIds.MCQ) {
        return "MCQ";
      } else if (
        (type.autoeval || type.autoeval === 1) &&
        (type.libtype || type.testtype) === constants.libTypeIds.CODING_SNIPPET
      ) {
        return "Coding Snippet";
      } else if (
        (type.libtype || type.testtype) ===
        constants.libTypeIds.CODING_CHALLENGE
      ) {
        return "Coding Challenge";
      } else if (
        type.videoqn === 1 &&
        (type.libtype || type.testtype) === constants.libTypeIds.DESCRIPTIVE
      ) {
        return "Video Assessment";
      } else {
        return "Descriptive";
      }
    }
  };

  const handleTest = (test) => {
    if (test.hasOwnProperty("toc")) {
      Alert.setLpId(test.id);
      localStorage.setItem("mockLp", true);
      sessionStorage.setItem("lpId", test.id);
      sessionStorage.setItem("mockStart", true);
      Alert.navigate("home");
    } else {
      let testData = {
        mockuse: true,
        testid: test.id,
        testname: test.name,
        testmode: test.mode,
        videoqn: test.videoqn,
        testtype: test.libtype,
        viewtest: test.viewtest,
        status: constants.PROGRESS_STATUS.UNLOCKED,
        proctored: test.videoqn || test.aiMode
          ? constants.PROCTORING_MODE.TAB_CAM
          : constants.PROCTORING_MODE.TAB,
        instruction: test.instruction !== "" ? test.instruction : null,
        learnerid: test.learnerid
          ? test.learnerid
          : getDataFromStorage("learnerid"),
        scope:test.scope,
      };

      console.log("test data :",testData);

      Alert.setStatus(testData.status);

      if (test.libtype === constants.libTypeIds.CODING_CHALLENGE) {
        testData.lmpid = test.lmpid;
          // test.status === constants.PROGRESS_STATUS.EVALUATED
          //   ? null
          //   : test.lmpid;
        testData.lmtid = test.lmtid;
          // test.status === constants.PROGRESS_STATUS.EVALUATED
          //   ? null
          //   : test.lmtid;
        console.log("testData 1 :",testData);
        handleCodingInfo(testData);
      } else {
        testData.autoeval = test.autoeval === 1;
        testData.configdata = {
          marks: test.marks,
          duration: test.testduration,
          questionscount: test.questionscount,
        };

        pathname === "/main/interview/library"
          ? (testData.ainterview = true)
          : (testData.ainterview = false);

        Alert.setCurrentStep(0);
        Alert.setTestData(testData);
        Alert.setShowInstruction(true);
        Alert.navigate("/instruction");
      }
    }
  };

  const handleCodingInfo = (test) => {
    console.log("test for the handlecodinginfo ",test);
    Alert.setIsLoaded(true);

    axios
      .post(
        "node/learner/course/test/config",
        JSON.stringify({
          mockuse: true,
          lpid: Alert.lpId,
          lmtid: test.lmtid,
          lmpid: test.lmpid,
          testid: test.testid,
          learnerid: test.learnerid,
          scope:test.scope,
        }),
        getHeaderDetailsForAxios(),
      )
      .then((res) => {
        test.data = res.data.data;
        Alert.setCurrentStep(0);
        Alert.setShowInstruction(false);
        console.log("test for setting testdata:",test);
        Alert.setTestData(test);
        if (!Alert.isAdmin) {
          Alert.navigate("/instruction");
        }
      })
      .catch((error) => {
        getCatchBlockDetails(error);
      })
      .finally(() => Alert.setIsLoaded(false));
  };

  return {
    scroll,
    getTime,
    handleTest,
    getTestType,
    mockTestRefs,
    handleSearch,
    handleCodingInfo,
  };
}
